// frontend/src/services/auth.ts
import http from "./http";

export type LoginInput = { email: string; password: string };

export type RoleCode = string | { code?: string; name?: string };

export type JwtMe = {
  sub: number;
  email?: string;
  company_id: number | null;
  roles: RoleCode[];
};

export type LoginResponseUser = {
  id: number;
  email: string;
  first_name?: string;
  last_name?: string;
  company_id: number | null;
  roles?: RoleCode[];
};

export type LoginResponse = {
  token: string;
  user: LoginResponseUser;
};

export function rolesToCodes(roles: RoleCode[] = []): string[] {
  return roles
    .map((r) => (typeof r === "string" ? r : r?.code || ""))
    .filter(Boolean);
}

function persistAuth(token: string, user: LoginResponseUser, remember = true) {
  const storage = remember ? localStorage : sessionStorage;
  storage.setItem("token", token);
  storage.setItem("user", JSON.stringify(user));
}

export function logoutLocal() {
  try {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("user");
  } catch {
    /* noop */
  }
}

/**
 * ✅ IMPORTANTE:
 * Aquí NO va "/api" adelante.
 * Porque http.baseURL YA contiene ".../api"
 */
export async function loginApi(body: LoginInput, remember = true): Promise<LoginResponse> {
  const data = (await http.post("/auth/login", body)) as LoginResponse;

  if (data?.token && data?.user) {
    logoutLocal();
    persistAuth(data.token, data.user, remember);
  }

  return data;
}

export async function meApi(): Promise<JwtMe> {
  const res = (await http.get("/auth/me")) as { user: JwtMe } | JwtMe;
  return (res as any)?.user ?? res;
}
